(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('attachmentsListConverter', ["$q", "fileDao", function ($q, fileDao) {
        return function (input, args) {
            var deferred = $q.defer();
            var promises = [];
            _(input.data.rows).each(function (row) {
                promises.push(fileDao.allScanDetails(row.entity_id, args.entityType, 'summary').then(function (response) {
                    row.scanStatus = response && response.data && response.data.scanStatus;
                    row.reportLinks = response && response.data && response.data.reportLinks;
                }));
            });
            $q.all(promises).then(function () {
                deferred.resolve(input);
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        };
    }]);
}());